module.exports = __webpack_public_path__ + "img/plagueherald.c7100793.png";